


















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class FilterControls extends Vue {

	@Prop() val!: string
	@Prop() col!: string

	filterText = ''

	@Watch('val', { immediate: true })
	valueChanged() {
		if(this.val !== this.filterText) {
			this.filterText = this.val
		}
	}

	clear() {
		this.filterText = ''
		this.$emit('filter', '', this.col)
	}

}
